module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-octagon-bff81e01.svg";